import React from 'react';
import PropTypes from 'prop-types';

const AntiForgeryToken = ({ token: { name, value } }) =>
  ((name && value)
    ? <input name={name} type="hidden" value={value} />
    : null);

AntiForgeryToken.propTypes = {
  token: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })
};

AntiForgeryToken.defaultProps = {
  token: {}
};

export default AntiForgeryToken;
